export default "__VITE_ASSET__X86G3OSz__"